<script>
import useTools from "@/use/Tools.js";
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import axios from "axios";

export default {
    name: "CvTechForm",
    setup() {
        const {$route} = useTools();
        const {loading, dialog} = useSharedData();
        const {getBack} = useSharedMethod();
        
        const pdfUrl = ref(null);
        
        const panelModel = ref(0);
        const cvTech = ref({});
        
        function findById(id) {
            loading.value = true;
            axios.get(`/cvTechs/${id}`).then((response) => {
                cvTech.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function download() {
            axios.get(`/cvTechs/download/${$route.params.id}`, {responseType: 'blob'}).then(response => {
                pdfUrl.value = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            });
        }
        
        onMounted(() => {
            findById($route.params.id);
            download();
        })
        
        return {
            loading,
            dialog,
            pdfUrl,
            panelModel,
            cvTech,
            getBack,
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="1300"
            scrollable
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.view')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="3">
                                <v-expansion-panels v-model="panelModel" dense focusable>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <strong>{{ $t('common.details') }}</strong>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mr-n5 ml-n5">
                                            <v-container fluid>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.lastName"
                                                            :label="$t('common.last_name')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.firstName"
                                                            :label="$t('common.first_name')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-date-picker
                                                            v-model="cvTech.birthDate"
                                                            :label="$t('common.birth_day')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.age"
                                                            :label="$t('common.age')"
                                                            type="number"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.address"
                                                            :label="$t('common.address')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.phone"
                                                            :label="$t('common.phone')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.email"
                                                            :label="$t('common.email')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-country-state-autocomplete
                                                            v-model="cvTech.stateId"
                                                            :label="$t('common.country_state')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-server-autocomplete
                                                            v-model="cvTech.specialityId"
                                                            api="dataSelects/type/RECRUITMENT_CV_TECH_SPECIALITY"
                                                            :label="$t('data_select.RECRUITMENT_CV_TECH_SPECIALITY')"
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <w-text-field
                                                            v-model="cvTech.yearOfExperience"
                                                            :label="$t('recruitment_request.experience')"
                                                            type="number"
                                                            readonly
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <strong>{{ $t('common.other') }}</strong>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mr-n5 ml-n5">
                                            <v-container fluid>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-radio-group
                                                            v-model="cvTech.sex"
                                                            row
                                                            class="mb-n7"
                                                        >
                                                            <v-radio value="M" :label="$t('common.man')" readonly/>
                                                            <v-radio value="F" :label="$t('common.woman')" readonly/>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox
                                                            v-model="cvTech.married"
                                                            :label="$t('recruitment_request.married')"
                                                            hide-details
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox
                                                            v-model="cvTech.hasChildren"
                                                            :label="$t('recruitment_request.has_children')"
                                                            hide-details
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox
                                                            v-model="cvTech.hasDriverLicense"
                                                            :label="$t('recruitment_request.has_driver_license')"
                                                            hide-details
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox
                                                            v-model="cvTech.hasValidPassport"
                                                            :label="$t('recruitment_request.has_passport')"
                                                            hide-details
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox
                                                            v-model="cvTech.hasCar"
                                                            :label="$t('recruitment_request.has_vehicle')"
                                                            hide-details
                                                            readonly
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox
                                                            v-model="cvTech.freeMilitaryService"
                                                            :label="$t('recruitment_request.free_military_service')"
                                                            hide-details
                                                            readonly
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <strong>{{ $t('recruitment_request.key_words') }}</strong>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mr-n5 ml-n5">
                                            <v-container fluid>
                                                <v-chip-group column>
                                                    <v-chip
                                                        v-for="(keyWord, index) in cvTech.keyWords"
                                                        :key="`keyWord-${cvTech.id}-${index}`"
                                                        small
                                                        label
                                                    >
                                                        <strong>{{ keyWord }}</strong>
                                                    </v-chip>
                                                </v-chip-group>
                                            </v-container>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <strong>{{ $t('recruitment_request.summary') }}</strong>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mr-n5 ml-n5">
                                            <v-container fluid>
                                                {{ cvTech.summary }}
                                            </v-container>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                            <v-col cols="9">
                                <iframe
                                    :src="pdfUrl"
                                    type="application/pdf"
                                    width="100%"
                                    height="700px"
                                    ref="pdfIframe"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>